import type { FC, KeyboardEvent as ReactKeyboardEvent, MouseEvent as ReactMouseEvent } from 'react';
import { optionalProp } from '../../core';
import { MLPVersion } from '../../types/enums';
import { type Data } from '../../DropDown/types/propsType';
import DropDown, { DropDownValidations } from '../../DropDown/DropDown';
import { TooltipPreference } from '../../Tooltip/Tooltip';
import { type CountrySelectorProps } from '../types/propsType';
import styles from '../PhoneNumber.module.scss';

const CountrySelector: FC<CountrySelectorProps> = ({
  dropdownDisabled,
  data,
  name,
  placeholder,
  onClearInput,
  dropdownLabel = '',
  dropdownValue,
  dropdownLabelInfo = '',
  dropdownLabelInfoPreference = TooltipPreference.RIGHT,
  configData,
  inputValue = '',
  status = DropDownValidations.DEFAULT,
  onClick,
  width,
  ...restProps
}): JSX.Element => (
  <section className={`${styles['country-selector-body']} ${dropdownDisabled ? styles['disabled'] : ''}`}>
    <DropDown
      isCountrySelector
      mlpVersion={MLPVersion.ONE}
      testId="country-dropDown"
      disabled={dropdownDisabled}
      name={name}
      autoComplete={'off'}
      value={inputValue}
      dropdownLabel={dropdownLabel}
      selectedCountry={(dropdownValue ? dropdownValue : data?.[0]) as Data}
      labelInfo={dropdownLabelInfo}
      labelInfoPreference={dropdownLabelInfoPreference}
      readOnly={dropdownDisabled}
      placeholder={dropdownValue ? '' : placeholder}
      status={status as DropDownValidations}
      {...optionalProp('onClearInput', onClearInput)}
      {...optionalProp('configData', configData)}
      {...optionalProp('data', data)}
      {...optionalProp('onClearInput', onClearInput)}
      {...optionalProp('width', width as string)}
      {...optionalProp('onClick', onClick as (e?: ReactKeyboardEvent | ReactMouseEvent) => void)}
      {...restProps}
    />
  </section>
);

export default CountrySelector;
